module.exports = __webpack_public_path__ + "img/flow_bind.4f8de5c3.png";